export default __webpack_public_path__ + "static/media/step-three.c314ef20.png";